import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClientWrapper } from "./http-client.wrapper";
import { Observable } from "rxjs";
import ProvisioningState, {
  ViewProvisioningState
} from "../models/provisioning-state";
import { CountDTO } from "../models/historical-state";

export interface IBulkProvisioningJSON {
  [key: string]: string[];
}

export interface IAppProvisioningJSON {
  devices: IBulkProvisioningJSON;
}

export interface IReProvisioningJSON {
  devicesIds: string[];
  rejectedDevice: string[];
  rejectedContainers: string[];
}

@Injectable()
export class ProvisioningControllerService {
  constructor(
    public httpClientWrapper: HttpClientWrapper<IReProvisioningJSON>,
    public httpClientWrapperCode: HttpClientWrapper<string>,
    public httpClientWrapperProvisioning: HttpClientWrapper<ProvisioningState>,
    public httpClientWrapperViewProvisioning: HttpClientWrapper<ViewProvisioningState>,
    public httpClientWrapperCount: HttpClientWrapper<CountDTO>
  ) {}

  update(data: string): Observable<IReProvisioningJSON> {
    return this.httpClientWrapper.postUnique(
      environment.apiBaseUrl +
        `device-containers/bulk-correcting/reprovisionning`,
      data
    );
  }

  checkContainers(codes: string[]): Observable<string[]> {
    return this.httpClientWrapperCode.post(
      environment.apiBaseUrl +
        `device-containers/bulk-correcting/check-containers`,
      codes
    );
  }

  getViewProvisioningStates(
    skip?: number,
    limit?: number,
    filterInput?: any
  ): Observable<ViewProvisioningState[]> {
    let filter: any = {};

    if (skip) filter.skip = skip;
    if (limit) filter.limit = limit;
    if (filterInput && Object.keys(filterInput).length)
      filter.where = filterInput;
    filter.order = "changeDate DESC";
    filter = {
      ...filter,
      where: {
        ...filter.where
      }
    };
    return this.httpClientWrapperViewProvisioning.get(
      `${environment.apiBaseUrl}view-provisioning-states?filter=${JSON.stringify(filter)}`
    );
  }

  getProvisioningStatesById(
    skip?: number,
    limit?: number,
    filterInput?: any,
    id?: string
  ): Observable<ProvisioningState[]> {
    let filter: any = {};

    if (skip) filter.skip = skip;
    if (limit) filter.limit = limit;
    if (filterInput && Object.keys(filterInput).length)
      filter.where = filterInput;
    filter.order = "changeDate DESC";
    filter = {
      ...filter,
      where: {
        ...filter.where,
        deviceId: id
      }
    };

    return this.httpClientWrapperProvisioning.get(
      `${environment.apiBaseUrl}provisioning-states?filter=${JSON.stringify(filter)}`
    );
  }

  countViewProvisioningStates(filterInput?: any): Observable<CountDTO> {
    let filterFormated: string = "?where=";
    let filter: any = {};
    if (filterInput) {
      filter = filterInput;
    }
    filterFormated = filterFormated + JSON.stringify(filter);

    return this.httpClientWrapperCount.getUnique(
      `${environment.apiBaseUrl}view-provisioning-states/count${filterFormated}`
    );
  }

  countProvisioningStatesById(
    filterInput?: any,
    id?: string
  ): Observable<CountDTO> {
    let filterFormated: string = "?where=";
    let filter: any = {};
    if (filterInput) {
      filter = filterInput;
    }
    filter = {
      ...filter,
      deviceId: id
    };
    filterFormated = filterFormated + JSON.stringify(filter);
    return this.httpClientWrapperCount.getUnique(
      `${environment.apiBaseUrl}provisioning-states/count${filterFormated}`
    );
  }
}
